import * as yup from 'yup';
import LangEnum from '../../../lang/LangEnum';
import { TranslateType } from '../../translation/translationContext.types';
import { ShareChannelEnum } from '../types/sharedEntities.enum';

export const shareCatalogSchema = (translate: TranslateType) => {
  const shareContactSchema = yup
    .object()
    .shape({
      id: yup.string().required(),
      name: yup.string().required(),
      email: yup.string().email(),
      newEmail: yup.string().email(),
    })
    .test(
      'email-or-newEmail',
      translate(LangEnum.SHARE_ENTITY_EMAIL_REQUIRED),
      (value) => !!value?.email || !!value?.newEmail,
    );

  return yup.object().shape({
    accessConfig: yup.string().required(),
    config: yup.object().shape({
      channelType: yup.string().oneOf(Object.values(ShareChannelEnum)).required(),
      emails: yup.array().when('channelType', {
        is: (channelType: ShareChannelEnum) => channelType === ShareChannelEnum.EMAIL,
        then: (schema) =>
          schema.of(shareContactSchema).min(1, translate(LangEnum.SHARE_ENTITY_EMAIL_REQUIRED)),
        otherwise: (schema) => schema.notRequired(),
      }),
      enableProductDetails: yup.boolean().required(),
      priceTableId: yup
        .string()
        .nullable()
        .when(['showSellInPrices', 'showSellOutPrices', 'isDefaultPriceTableId'], {
          is: (
            showSellInPrices: boolean,
            showSellOutPrices: boolean,
            isDefaultPriceTableId: boolean,
          ) => showSellInPrices && showSellOutPrices && !isDefaultPriceTableId,
          then: (schema) => schema.required(translate(LangEnum.SHARE_ENTITY_PRICE_TABLE_REQUIRED)),
          otherwise: (schema) => schema.nullable(),
        }),
      showAvailableStock: yup.boolean().required(),
      showSellInPrices: yup.boolean().required(),
      showSellOutPrices: yup.boolean().required(),

      isDefaultPriceTableId: yup.boolean().required(),
    }),
  });
};
